// extracted by mini-css-extract-plugin
export default {"root":"x8HM9U6JQ1DkmlWSc6el"};